import React, { Fragment, useEffect, useState, useContext } from "react";
import SikkaCardHeader from "../../common/SikkaCardHeader";
import { Alert, Row, Col, Card, CardBody, CardHeader, Modal, ModalHeader, ModalBody, Input } from "reactstrap";
import {
  Nav,
  Form,
  TabContainer,
  TabContent,
  TabPane,
  Button,
  FormGroup,
  FormLabel,
  NavLink,
  NavItem,
} from "react-bootstrap";

import ButtonIcon from "../../common/ButtonIcon";
import Loader from "../../common/Loader";
import APICall from "../../../services/apiCall";
import { toast } from "react-toastify";
import { isIterableArray } from "../../../helpers/utils";
import ModalCustom from "../../common/ModalCustom";
import Select from "react-select";
import Flex from "../../common/Flex";
import APIAccessListItem from "./APIAccessListItem";
import AppContext from "../../../context/Context";
import SikkaInput from "../../common/SikkaInput";
import { useForm } from "react-hook-form";
import Scrollbar from "react-scrollbars-custom";
import SikkaSelect from "../../common/SikkaSelect/SikkaSelect";

const NavItemComponent = ({ item }) => {
  return (
    <NavItem as="li">
      <NavLink className="mb-0 py-2 cursor-pointer fs--1" eventKey={item}>
        {item}
      </NavLink>
    </NavItem>
  );
};

const navItems = ["GET", "POST", "PUT", "DELETE", "PATCH"];

const selectStyles = {
  control: (base) => ({
    ...base,
    fontSize: "12px",
    height: 33,
    minHeight: 33,
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
  }),
};

const APIAccessDetails = ({
  applicationDetails,
  appid,
  isActionAllowed,
  applicationList,
  fetchApiAccessList,
  setFetchApiAccessList,
  showApiAccessButtonClickedCancel,
  setShowApiAccessButtonClickedCancel,
  selectedApiNames,
  setSelectedApiNames,
  apiLimitNote,
  setApiLimitNote,
}) => {
  const [loading, setLoading] = useState(false);
  const [apiAccessData, setApiAccessData] = useState({});
  const [apiAccessList, setApiAccessList] = useState([]);
  const [openAPIAccessModal, setOpenAPIAccessModal] = useState(false);
  const [domainIdx, setDomainIdx] = useState(0);
  const [key, setKey] = useState("GET");
  const [apiAccessNameData, setApiAccessNameData] = useState([]);
  const [apiAccessModalDataBeforeUpdate, setApiAccessModalDataBeforeUpdate] = useState();
  const [orginalApiAccessData,setOrginalApiAccessData]=useState({})
  const [otherApis, setOtherApis] = useState("");
  const [fetchAfterUpdate, setFetchAfterUpdate] = useState(false);
  const [selectedApiNamesForOtherApis, setSelectedApiNamesForOtherApis] = useState([]);
  const [disableApiAccessSelection, setDisableApiAccessSelection] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // useEffect(() => {
  //   setApiAccessModalDataBeforeUpdate({
  //     api_limit_id: apiAccessData?.sikka_limit,
  //     app_id: appid,
  //     api_names: selectedApiNames.join(","),
  //     api_limit_note: apiLimitNote,
  //     domain_name: domains[domainIdx],
  //   });
  // }, [apiAccessData]);

  const { loginUserDetails, accessToken } = useContext(AppContext);

  useEffect(() => {
    //this block of code is not being called because App id not being Change Even When ApiAccess Is Added
    if (appid) {
      setFetchAfterUpdate(true);
    } else {
      setApiAccessList([])//if there is no appid => partner has no Application =>ApiAccessList is set to Empty Array
      setFetchAfterUpdate(false);
    }
  }, [appid]);

  const handleChange = (apiName, selected) => {
    if (loginUserDetails.is_partner === "0") {
      if (selected) {
        const updatedTodos = selectedApiNames.concat(apiName);
        setSelectedApiNames(updatedTodos);
      } else {
        const updatedTodos = selectedApiNames.filter((name) => name !== apiName);
        setSelectedApiNames(updatedTodos);
      }
    } else {
      if (selected && selectedApiNames.length < 14) {
        const updatedTodos = selectedApiNames.concat(apiName);
        setSelectedApiNames(updatedTodos);
      } else if (selected) {
        const updatedTodos = selectedApiNames.concat(apiName);
        setSelectedApiNames(updatedTodos);
        setDisableApiAccessSelection(true);
        toast.warning("Max limit of API Access reached for the selected plan");
      } else {
        const updatedTodos = selectedApiNames.filter((name) => name !== apiName);
        setSelectedApiNames(updatedTodos);
        setDisableApiAccessSelection(false);
      }
    }
  };
  const getApiLink =(obj) =>
  {
    const mainUrlForDocumentation="https://apidocs.sikkasoft.com/"
    //to check if the obj is Object
    if(typeof(obj ) =="object")
    {
      if(obj?.documentLinkV4.substr(30) !="")
      {
        return obj.documentLinkV4        
      }
      if(obj?.documentLinkV2.substr(30) !="")
      {
        return obj.documentLinkV2        
      }
    }
    return mainUrlForDocumentation
    }
  const setLinkForApiAccess =(arr)=>{
    setLoading(true);
    var apiParam = { allowed_api_list: arr.join(","),user_dev_id:loginUserDetails.dev_id };
    
    APICall.servertrip("POST", "api_list_with_links", loginUserDetails, undefined,apiParam).then(
      (res) => {
        setLoading(false);
        setApiAccessList(res.data.items);      
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        setLoading(false);
      }
    );

  };
  useEffect(() => {
    if (appid && fetchAfterUpdate || fetchApiAccessList) {
      setLoading(true);
      var apiParam = { appid: appid };
      setOrginalApiAccessData({})
      APICall.servertrip("GET", "api_access_list", loginUserDetails, apiParam).then(
        (res) => {
          setLoading(false);
          setFetchAfterUpdate(false);
          setFetchApiAccessList(false)
          setApiAccessData(res.data.items[0]);
          if (res.data.items[0] && res.data.items[0].allowed_api_list) {
            var arr = res.data.items[0].allowed_api_list.split(",");
            setSelectedApiNames(
              res.data.items[0].allowed_api_list.split(",").map(function(item) {
                return item.trim();
              })
            );
            setApiAccessList(arr);
            setLinkForApiAccess(arr) // I am using this to add link 
            setApiLimitNote(res.data.items[0].app_limit_note);
            setOrginalApiAccessData({
              api_limit_id: apiAccessData?.sikka_limit,
              app_id: appid,
              api_names:  res.data.items[0].allowed_api_list.split(",").map(function(item) {return item.trim()}).join(","),
              api_limit_note: res.data.items[0].app_limit_note,
              domain_name: domains[domainIdx],
            })
          } else {
            setApiAccessList([]);
          }
        },
        (error) => {
          const resMessage =
            (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
          setLoading(false);
          toast.error(resMessage);
          setFetchApiAccessList(false)
          setFetchAfterUpdate(false);
        }
      );
    }
  }, [fetchAfterUpdate,fetchApiAccessList]);

  useEffect(() => {
    let params = {
      
    };
    if (loginUserDetails.is_partner === "1") {
      params = {
        is_devloper: true,
      };
    } else {
      params = {
        is_devloper: false,
      };
    }

    params["devid"]=loginUserDetails.dev_id;
    
    setSelectedApiNamesForOtherApis([]);   
    if (fetchAfterUpdate || openAPIAccessModal) {
      APICall.servertrip("GET", "api_name_for_access", loginUserDetails, params).then(
        (res) => {
          if (loginUserDetails.is_partner === "1") {
            let apiAccessNameData = {
              get: [],
              post: [],
              put: [],
              delete: [],
              patch: [],
            };
            res.data.items.map((data) => {
              if (data.method === "GET") {
                apiAccessNameData["get"].push(data.api_name);
              } else if (data.method === "POST") {
                apiAccessNameData["post"].push(data.api_name);
              } else if (data.method === "PUT") {
                apiAccessNameData["put"].push(data.api_name);
              } else if (data.method === "PATCH") {
                apiAccessNameData["patch"].push(data.api_name);
              } else if (data.method === "DELETE") {
                apiAccessNameData["delete"].push(data.api_name);
              }
            });
            setApiAccessNameData(apiAccessNameData);
          } else {

            let tempSelectedApiNamesForOtherApis = [...selectedApiNames];
            for (const methodName in res?.data?.items?.[0]) {
              for (const apiName in res?.data?.items?.[0][methodName]) {
                for (const individualApiName of res.data.items[0][methodName][apiName]) {
                  const removedApiName = tempSelectedApiNamesForOtherApis.indexOf(individualApiName);
                  if (removedApiName > -1) {
                    // only splice array when item is found
                    tempSelectedApiNamesForOtherApis.splice(removedApiName, 1); // 2nd parameter means remove one item only
                  }
                }
              }
            }
            
            setApiAccessNameData(res.data?.items);
            setSelectedApiNamesForOtherApis(tempSelectedApiNamesForOtherApis);
          }
          setFetchAfterUpdate(false);
        },
        (error) => {
          const resMessage =
            (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
          setLoading(false);
          toast.error(resMessage);
          setFetchAfterUpdate(false);
        }
      );
    }

    
  }, [fetchAfterUpdate, openAPIAccessModal]); 


  

  const domains = ["all"];

  const handleAddingOfAPIAccess = (values) => {
    setIsDisable(true)
    setFetchAfterUpdate(false);
    let deepCopySelectedApiNames = [...selectedApiNames];
    selectedApiNamesForOtherApis.forEach((data) => {
      let index = deepCopySelectedApiNames.indexOf(data);
      deepCopySelectedApiNames.splice(index, 1);
    });
    let selectApis =
      deepCopySelectedApiNames.length > 0
        ? values.otherAPIs
          ? deepCopySelectedApiNames
              .filter((data) => data)
              .join(",")
              .concat(",")
              .concat(
                values.otherAPIs
                  .split(",")
                  .map((data) => data.trim())
                  .join(",")
              ).split(',').sort().join(',')
          : deepCopySelectedApiNames.filter((data) => data).sort().join(",")
        : values.otherAPIs
            .split(",")
            .map((data) => data.trim()).sort()
            .join(",");

    if (apiAccessList.sort().join(",") !== selectApis) {
      if (apiAccessList?.length > 0) {
        // PUT Req, apiAccessList is not empty
        let body = {
          api_limit_id: apiAccessData.sikka_limit,
          app_id: appid,
          api_names: selectApis,
          api_limit_note: values.apiLimitNote || applicationDetails.app_name,
          domain_name: domains[domainIdx],
          add_updated_by: loginUserDetails.user_name,
          before_updated_value: orginalApiAccessData,
          user_dev_id:loginUserDetails.dev_id
        };
        APICall.servertrip("PUT", "api_access", loginUserDetails, undefined, body).then(
          (res) => {
            setOpenAPIAccessModal(false);
            setOtherApis("");
            setFetchAfterUpdate(true);
            toast.success("API Access Details Saved Successfully");
            setSelectedApiNames([]);
            setApiLimitNote("");
          },
          (error) => {
            const resMessage =
              (error.response && error.response.data && error.response.data.message) ||
              error.message ||
              error.toString();
            setIsDisable(false)
            setLoading(false);
            setFetchAfterUpdate(true);
            toast.error(resMessage);
          }
        );
      } else {
        // POST Req
        let body = {
          app_id: appid, // application ID
          api_names: selectApis, //Selected API by seperated comma
          api_limit_note: values.apiLimitNote || applicationDetails.app_name, // you can add For <application name>
          domain_name: domains[domainIdx], //value must be all for now.
          add_updated_by: loginUserDetails.user_name, // Logged in username
          user_dev_id:loginUserDetails.dev_id
        };
        APICall.servertrip("POST", "api_access", loginUserDetails, undefined, body).then(
          (res) => {
            setOpenAPIAccessModal(false);
            setOtherApis("");
            setFetchAfterUpdate(true);
            setShowApiAccessButtonClickedCancel(false);
            setSelectedApiNames([]);
            setApiLimitNote("");
          },
          (error) => {
            const resMessage =
              (error.response && error.response.data && error.response.data.message) ||
              error.message ||
              error.toString();
              setIsDisable(false)
              setLoading(false);
            toast.error(resMessage);
          }
        );
      }
    } else {
      setIsDisable(false)
      toast.warning("No API Access Details has been changed.");
      // setOpenAPIAccessModal(false);
    }
  };
  
  return (
    <Card className="mb-3">
      <Fragment>
        <SikkaCardHeader title="API Access Detail">
          <div className="d-flex mt-2">
            {(loginUserDetails.is_partner === "0" &&
              isActionAllowed("liAddTeamMemberButton") &&
              applicationList.length > 0) ? (
              <ButtonIcon
                color="outline-primary"
                size="sm"
                icon="edit"
                className="mr-2 mb-2"
                onClick={(e) => {
                  setOpenAPIAccessModal(true);
                  setIsDisable(false)
                }}
              >
                API Access
              </ButtonIcon>
            ) : (
              <div />
            )}
          </div>
        </SikkaCardHeader>
        <CardBody className="border-top cardbody-scroll-area">
          {loading ? (
            <Loader />
          ) : (
            <Scrollbar style={{ height: applicationList.length > 0 ? "500px" : "50px" }}>
              {isIterableArray(apiAccessList) ? (
                <Col className="pl-0 pr-2" sm={12}>
                  <ul className="list-group">
                    {apiAccessList.map((apiName, index) => (
                      <li key={index} className="list-group-item fs--1" >
                        <a target="_blank" href={getApiLink(apiName)}>{index +1}. {apiName.apiName}</a>                       
                      </li>
                    ))}
                  </ul>
                </Col>
              ) : applicationList.length > 0 ? (
                <Alert className="alert alert-info mb-0" role="alert">
                  API access not set for this application.
                </Alert>
              ) : (
                <Alert className="alert alert-info mb-0" role="alert">
                  No applications for this partner.
                </Alert>
              )}
            </Scrollbar>
          )}

          <>
            <Modal
              isOpen={openAPIAccessModal}
              toggle={() => {
                setOpenAPIAccessModal(false);
              }}
              onClosed={() => {
                setOpenAPIAccessModal(false);
              }}
              size="xl"
              scrollable={true}
              centered
              // style={{ maxWidth: "700px", width: "100%" }}
            >
              <ModalHeader
                toggle={() => {
                  setOpenAPIAccessModal(!openAPIAccessModal);
                }}
              >
                Manage API Access
              </ModalHeader>
              <ModalBody className="fs--1 font-weight-normal p-0 overflow-hidden">
                <Form onSubmit={handleSubmit(handleAddingOfAPIAccess)}>
                  <Row className="p-0">
                    <Col>
                      <Row>
                        <Col className="col-sm-6 col-12">
                          <FormGroup
                            as={Col}
                            className="mb-3 align-items-center pl-3 pt-3"
                            controlId="formHorizontalPassword"
                          >
                            <FormLabel className="d-sm-flex pl-0" style={{ fontSize: "13px" }} column>
                              Domain(s)
                            </FormLabel>
                            <SikkaSelect
                              placeholder="Select a practice"
                              // styles={selectStyles}
                              classNamePrefix="react-select"
                              options={domains.map((option, index) => {
                                return {
                                  value: index,
                                  label: option,
                                };
                              })}
                              value={{
                                value: domainIdx,
                                label: domains[domainIdx],
                              }}
                              onChange={(selectedOption) => {
                                setDomainIdx(selectedOption.value);
                                apiAccessData.app_domain = domains[selectedOption.value];
                                setApiAccessData([...apiAccessData]);
                              }}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup
                            className="mb-3 pl-sm-3 pl-0"
                            controlId="formHorizontalPassword"
                            style={{ paddingTop: "18px" }}
                          >
                            <Col sm={12}>
                              <SikkaInput
                                label="API Limit Note*"
                                name="apiLimitNote"
                                id="apiLimitNote"
                                defaultValue={apiLimitNote}
                                placeholder="Enter API Limit Note"
                                size="lg"
                                innerRef={register({
                                  required: "API Limit Note is required",
                                })}
                                errors={errors}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Col className="p-0">
                        <Card>
                          <TabContainer id="audience-tab" defaultActiveKey="GET">
                            <CardHeader
                              as={Flex}
                              justifyContent="between"
                              alignItems="center"
                              className="ps-0 py-0 border-bottom"
                            >
                              <Nav as="ul" className="nav-tabs border-0 chart-tab tab-active-caret sm">
                                {navItems.map((item) => (
                                  <NavItemComponent item={item} key={item} />
                                ))}
                              </Nav>
                            </CardHeader>

                            <CardBody>
                              <Row className="g-1">
                                <Col>
                                  {loginUserDetails.is_partner === "1" ? (
                                    <TabContent>
                                      {/* 0-------------------- */}
                                      <TabPane unmountOnExit eventKey="GET">
                                        <APIAccessListItem
                                          method="GET"
                                          data={apiAccessNameData["get"]}
                                          handleChange={handleChange}
                                          selectedApiNames={selectedApiNames}
                                          disableApiAccessSelection={disableApiAccessSelection}
                                        />
                                      </TabPane>
                                      {/* 1-------------------- */}
                                      <TabPane unmountOnExit eventKey="POST">
                                        <APIAccessListItem
                                          method="POST"
                                          data={apiAccessNameData["post"]}
                                          handleChange={handleChange}
                                          selectedApiNames={selectedApiNames}
                                          disableApiAccessSelection={disableApiAccessSelection}
                                        />
                                      </TabPane>
                                      {/* 2-------------------- */}
                                      <TabPane unmountOnExit eventKey="PUT">
                                        <APIAccessListItem
                                          method="PUT"
                                          data={apiAccessNameData["put"]}
                                          handleChange={handleChange}
                                          selectedApiNames={selectedApiNames}
                                          disableApiAccessSelection={disableApiAccessSelection}
                                        />
                                      </TabPane>
                                      {/* 3-------------------- */}
                                      <TabPane unmountOnExit eventKey="DELETE">
                                        <APIAccessListItem
                                          method="DELETE"
                                          data={apiAccessNameData["delete"]}
                                          handleChange={handleChange}
                                          selectedApiNames={selectedApiNames}
                                          disableApiAccessSelection={disableApiAccessSelection}
                                        />
                                      </TabPane>
                                      {/* 4-------------------- */}
                                      <TabPane unmountOnExit eventKey="PATCH">
                                        <APIAccessListItem
                                          method="PATCH"
                                          data={apiAccessNameData["patch"]}
                                          handleChange={handleChange}
                                          selectedApiNames={selectedApiNames}
                                          disableApiAccessSelection={disableApiAccessSelection}
                                        />
                                      </TabPane>
                                    </TabContent>
                                  ) : (
                                    <TabContent>
                                      {/* 0-------------------- */}
                                      <TabPane unmountOnExit eventKey="GET">
                                        <APIAccessListItem
                                          method="GET"
                                          data={apiAccessNameData[0]?.["get"]}
                                          handleChange={handleChange}
                                          selectedApiNames={selectedApiNames}
                                        />
                                      </TabPane>
                                      {/* 1-------------------- */}
                                      <TabPane unmountOnExit eventKey="POST">
                                        <APIAccessListItem
                                          method="POST"
                                          data={apiAccessNameData[0]?.["post"]}
                                          handleChange={handleChange}
                                          selectedApiNames={selectedApiNames}
                                        />
                                      </TabPane>
                                      {/* 2-------------------- */}
                                      <TabPane unmountOnExit eventKey="PUT">
                                        <APIAccessListItem
                                          method="PUT"
                                          data={apiAccessNameData[0]?.["put"]}
                                          handleChange={handleChange}
                                          selectedApiNames={selectedApiNames}
                                        />
                                      </TabPane>
                                      {/* 3-------------------- */}
                                      <TabPane unmountOnExit eventKey="DELETE">
                                        <APIAccessListItem
                                          method="DELETE"
                                          data={apiAccessNameData[0]?.["delete"]}
                                          handleChange={handleChange}
                                          selectedApiNames={selectedApiNames}
                                        />
                                      </TabPane>
                                      {/* 4-------------------- */}
                                      <TabPane unmountOnExit eventKey="PATCH">
                                        <APIAccessListItem
                                          method="PATCH"
                                          data={apiAccessNameData[0]?.["patch"]}
                                          handleChange={handleChange}
                                          selectedApiNames={selectedApiNames}
                                        />
                                      </TabPane>
                                    </TabContent>
                                  )}
                                </Col>
                              </Row>
                              <Row className="mt-3 d-flex justify-content-between align-items-center">
                                {loginUserDetails.is_partner === "0" && (
                                  <FormGroup className="" controlId="formHorizontalPassword">
                                    <FormLabel style={{ fontSize: "13px" }} column>
                                      Other APIs
                                    </FormLabel>
                                    <Col sm={12} className="d-flex">
                                      <Input
                                        label="Other APIs"
                                        name="otherAPIs"
                                        id="otherAPIs"
                                        innerRef={register()}
                                        defaultValue={selectedApiNamesForOtherApis.join(",")}
                                        placeholder="Enter API Names"
                                        size="sm"
                                        errors={errors}
                                      />
                                    </Col>
                                  </FormGroup>
                                )}
                                <FormGroup>
                                  <Col className="d-flex justify-content-end pt-3">
                                    <Button disabled={isDisable} className="mr-2" type="submit" variant="outline-primary" size="sm">
                                      Save
                                    </Button>
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      onClick={(e) => {
                                        setOpenAPIAccessModal(false);
                                      }}
                                    >
                                      Cancel
                                    </Button>
                                  </Col>
                                </FormGroup>
                              </Row>
                            </CardBody>
                          </TabContainer>
                        </Card>
                      </Col>
                    </Col>
                  </Row>
                </Form>
              </ModalBody>
            </Modal>
          </>
        </CardBody>
      </Fragment>
    </Card>
  );
};
export default APIAccessDetails;
